"use client";
import Script from "next/script";

// NOTE: Should always be loaded. Consent is irrelevant here. Consent is checked when ads are requested

//#region [Component]
export default function AdnuntiusScript() {
    return <Script id="adnuntiusMainScript">
        {`
						(function(d, s, e, t){e=d.createElement(s);e.type='text/java'+s;e.async='async';e.src='http'+('https:'===location.protocol?'s':'')+'://cdn.adnuntius.com/adn.js';t=d.getElementsByTagName(s)[0]; t.parentNode.insertBefore(e, t);})(document,'script');
						window.adn = window.adn || {}; adn.calls = adn.calls || [];
					`}
    </Script>;
}
//#endregion